module.exports = __webpack_public_path__ + "img/glassquality_3.1ac018bf.png";